<section id="rowsDisplayContainer" class="p-4 w-max">
  <article class="text-lg font-bold">
    {{ literalService.get('bookings.rowsNumberInput', true) }}
  </article>
  <article class="pt-4">
    <input class="block min-w-[232px] px-3 py-2 bg-white border rounded-s rounded-e text-base font-normal placeholder-slate-400 focus:outline-none" type="text" inputmode="numeric" maxlength="2" [value]="value" (change)="handleChange($event)" (keydown)="onKeyDown($event)" />
  </article>
</section>